import React, { Component } from "react";
import { FontAwesomeIcon }            from '@fortawesome/react-fontawesome'
import ReactPhoneInput                from "react-phone-input-2";
import { Button, Modal, FormControl, PageHeader, Row, Col } from "react-bootstrap";
import { invokeSetCreateReminder }    from "../../utils/AwsInvoke";
import { Colors }                     from "../../utils/Colors";
import LoaderButton                   from "../../components/LoaderButton";
import ModalAlert                     from "../../components/modal/ModalAlert";
import ModalTrainerTextMsg            from "../../components/modal/ModalTrainerTextMsg";
import { EmailRegEx }                 from "../../utils/EmailRegEx";
import uniqueId                       from 'lodash/uniqueId';
import SortDropdownTrainerLocation    from "../../components/utils/SortDropdownTrainerLocation";
import { invokeSendEmailNewTrainerSignup,
         invokeSendEmailResetTrainerLoginPassword,
         invokeGetNewClientDetail,
         invokeGetTrainerProfileDetail,
         invokeCheckIfClientEmailExists,
         invokeAddClientProfile,
         invokeSetDeleteClient } from "../../utils/AwsInvoke";
import { doesTrainerHaveValidPhoneNumber } from "../../utils/CheckIfValidPhoneNumber";
import "../../css/modal/ModalCreateFolder.css";
import "../../css/modal/ModalTrainerDetail.css";

export default class ModalTrainerDetail extends Component {

    constructor(props) {
        super(props);
        var company_id      = this.props.trainerCompanyId;
        var trainer_id      = this.props.trainerId;
        var location_abbrev = this.props.trainerLocationAbbrev;
        var phone           = this.props.trainerPhoneNum;
        if(trainer_id == "") trainer_id = undefined;
        if(company_id == "") company_id = undefined;

        this.state = {
            showModalSimple: false,
            title: "",
            first_name: "",
            last_name: "",
            email: "",
            phone: phone,
            //trainerPhoneNum: phone,
            trainerId: trainer_id,
            trainerCompanyId: company_id,
            trainerLocationAbbrev: location_abbrev,
            trainerName: this.props.trainerName,
            showTrainerForm: false,
            showModalAlert:  false, // true | false
            showModalTrainerTextMsg: false,
            error: ""
        };
    }

    componentDidMount = () => {
        var trainer_id = this.state.trainerId;
        this.setState({
            showTrainerForm: this.props.showTrainerForm
        })

        this.getTrainerDetail(trainer_id);
    }

    getTrainerDetail = async (trainer_id) => {
        var show_single_trainer = true; // show only a trainer's clients (not all trainers from a gym location)
        var number_of_total_results = 100;
        const results = await invokeGetTrainerProfileDetail(trainer_id, show_single_trainer, number_of_total_results);

        if(results) {
            this.setState({
                trainerDetail: results.data
            })
        }
    }

    componentWillUnmount() {
        // Reset Input Values
        this.setState({
            title: "",
            error: ""
        });
    }

    handleTitleChange (event) {
        this.setState({
            title: event.target.value
        });
    }

    handleNotesChange = (event) => {
        this.setState({ notes: event.target.value});
    }

    handleFirstNameChange  = (event) => {
        var text = event.target.value;
        this.setState({
            first_name: text
        });
    }

    handleLastNameChange  = (event) => {
        var text = event.target.value;
        this.setState({
            last_name: text
        });
    }

    handleEmailChange  = (event) => {
        var text = event.target.value;
        this.setState({
            email: text
        });
    }

    handlePhoneChange  = (text) => {
        this.setState({
            phone: text
        });
    }

    getClientData = async (trainer_id) => {

        if(trainer_id != "undefined") {
                this.setState({
                    title: "Member Profile",
                    loadingData: "Loading member data ... "
                })
                const results = await invokeGetNewClientDetail(trainer_id);

                if(results) {
                    var data        = results.data.client_data[0];
                    var first_name  = data.first_name;
                    var last_name   = data.last_name;
                    var email       = data.email;
                    var phone       = data.phone;
                    var notes       = data.notes;
                    var photo_id    = data.photo_id;
                    var company_name = data.company_name;

                    if(first_name === null) first_name = "";
                    if(last_name  === null) last_name = "";
                    if(email === null)      email = "";
                    if(notes === null)      notes = "";
                    if(photo_id === null)   photo_id = "";
                    if(phone === null)      phone = "";
                        else {
                            var res = phone.charAt(1)
                            // Check if a space already exists after the area code +1;
                            // if there are too many spaces it will cause a "string too long" error
                            if(res != " ") phone = phone.slice(0, 1) + " " + phone.slice(1); // adds space after "1" for USA are code
                    }

                    this.setState({
                        first_name: first_name,
                        last_name:  last_name,
                        email:      email,
                        phone:      phone,
                        notes:      notes,
                        photo_id:   photo_id,
                        isLoading:  false,
                        showTrainerForm: true
                    });

                    //this.msgDataLoaded();
                } else {
                    //this.msgDataLoaded();

                }
        } else
            this.setState({ title: "Create New Member" })
    }

    handleSubmit = async event => {
            //event.preventDefault();

            var trainer_id   = this.state.trainerId;
            var company_id  = this.state.trainerCompanyId;
            var first_name  = this.state.first_name;
            var last_name   = this.state.last_name;
            var email       = this.state.email;
            var phone       = this.state.phone;
            var notes       = this.state.notes;
            var is_trainer  = true;
            console.log("handleSubmit company_id: "+ company_id);
            var first_text         = "A First Name is required.";
            var email_text         = "An Email is required.";
            var email_valid_text   = "Please enter a valid email address.";
            var email_exists_text  = "Sorry, the user email already exists. Please use a different one.";
            var phone_text         = "A Phone # is required.";

            if(trainer_id == undefined || trainer_id == "undefined") trainer_id = "new";

            if(company_id === undefined)
                this.setModalAlertProps("Warning", "A Gym Location is required.", true); // title_text, body_text, show_modal
            else if(first_name === "")
                this.setModalAlertProps("Warning", first_text, true); // title_text, body_text, show_modal
            else if(email === "")
                this.setModalAlertProps("Warning", email_text, true); // title_text, body_text, show_modal
            else if(!EmailRegEx(email)) {
                // If email is not valid
                this.setModalAlertProps("Warning", email_valid_text, true); // title_text, body_text, show_modal
            } else if(phone === "")
                this.setModalAlertProps("Warning", phone_text, true); // title_text, body_text, show_modal
            else {
                try {
                    let results_email = await invokeCheckIfClientEmailExists(email);
                    let count = results_email.count;
                    let email_owner_id = results_email.user_id;

                    ////  Check if the user's id of the email address is the same as the email to be changed to, if it is,
                    ////  then no need to check if the email is the same or not; otherwise, the user will never be able to
                    ////  change the user's properties like first/last name, etc....
                    if(count > 0 && email_owner_id != trainer_id) {
                        this.setModalAlertProps("Warning", email_exists_text, true); // title_text, body_text, show_modal
                        return
                    }

                    this.setState({ isLoading: true, showLoadingBar: "inline" });
                    let photo_id = undefined; // temp replace
                    /* temp remove but works 10/15
                    let photo_id = this.file ? await s3PublicUpload("profile-photos", this.file) : null;

                    // If there's an eisting image and a new one hasn't been uploaded, use existing image
                    if(photo_id === null || photo_id === undefined)
                        photo_id = this.state.photo_id;
                    */

                    const results = await invokeAddClientProfile(trainer_id, first_name, last_name, email, phone, notes, company_id, photo_id, is_trainer);

                    if(results.status === true) {
                        this.setState({
                            isLoading: false,
                            showLoadingBar: "none"
                        });
                        this.props.onHide();
                        this.props.resetTrainerList();
                    } else {
                        var body_text  = "Sorry, we had problems adding the Trainer. Please try again.";
                        this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
                        this.setState({ isLoading: false, showLoadingBar: "none" });
                    }
                } catch (e) {
                    alert(e);
                    this.setState({ isLoading: false, showLoadingBar: "none" });
                }
            }
    }


    ////   SHOW THE ALERT MODAL   ////
    setModalAlertProps = (title_text, body_text, show_modal) => {
        var alert_object = {};
        var alert_action = "";

        this.setState({
            modalAlertTitleText: title_text,
            modalAlertBodyText:  body_text,
            showModalAlert:      show_modal, // true | false
            alertObject:         alert_object,
            alertAction:         alert_action
        })
    }

    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13) {
             this.props.onHide();
             this.handleSubmit();
        }
    }

    cancel () {
        this.props.onHide();
    }

    showLoadingOverlay (msg) {
        this.setState({
            loadingData: msg,
            showLoadingBar: "inline"
        })
    }

    sendSignupEmail = async event => {
        event.preventDefault();
        this.setState({
            error: "An email is being sent to the user ..."
        })
        //this.showLoadingOverlay("An email is being sent to the user ...")
        var email     = this.props.trainerEmail;
        var full_name = this.props.trainerName;
        var location  = this.state.trainerLocationAbbrev; // dynmically generate signup/password link
        const results = await invokeSendEmailNewTrainerSignup(email, full_name, location);

        if(results) {
            this.setState({error: ""})
            var body_text  = "Sweet, " + full_name + " was sent an email to sign-up for Training Slate.";
            this.setModalAlertProps("Information", body_text, true); // title_text, body_text, show_modal
        } //else
            //this.msgDataLoaded();
    }

    sendResetPasswordEmail = async event => {
        event.preventDefault();
        this.setState({
            error: "An email is being sent to the user ..."
        })
        //this.showLoadingOverlay("An email is being sent to the user ...")
        var email     = this.props.trainerEmail; //"klusurf@gmail.com";
        var full_name = this.props.trainerName; // "Kevin Lu";
        var location  = this.state.trainerLocationAbbrev; // dynmically generate signup/password link
        const results = await invokeSendEmailResetTrainerLoginPassword(email, full_name, location);

        if(results) {
            this.setState({error: ""})
            var body_text  = "Nice, " + full_name + " was sent an email to reset their login password.";
            this.setModalAlertProps("Information", body_text, true); // title_text, body_text, show_modal
        }// else
            //this.msgDataLoaded();
    }

    async deleteMember () {
        this.setState({
            pageOverlay: "none",
            showDeleteConfirmWin: false,
            loadingData: "Deleting member ... ",
            showLoadingBar: "inline"
        });
        var trainer_id = this.state.trainerId;

        var results = await invokeSetDeleteClient(trainer_id);

        if(results.status) {
            this.cancel();
            this.props.resetTrainerList();
        } else {
            this.cancel();
            this.props.resetTrainerList();
        }
    }

    editTrainerProfile = () => {
        var trainer_id = this.state.trainerId;
        if(trainer_id != undefined) {
            this.setState({
                error: "Loading trainer data ..."
            }, function() {
                this.getClientData(trainer_id);
            })
        }
    }

    sendTrainerTextMsg = (athlete_id, athlete_name, program_name, last_login_date) => {
        var trainer_number = doesTrainerHaveValidPhoneNumber(this.state.phone);

        if(trainer_number == false) {
            //alert("Sorry, before you send a text message, you need to add a valid trainer number.")
            var body_text  = "Sorry, before you send a text message, you need to add a valid trainer number.";
            this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
            this.setState({ isLoading: false, showLoadingBar: "none" });
            return false;
        }

        this.setState({
            showModalAlert: false,
            showModalTrainerTextMsg: true,
            athleteId: athlete_id,
            athleteName: athlete_name,
            athleteLastLogin: last_login_date,
            programName: program_name,
            trainerTextPhone: trainer_number
        });
    }

    getTrainerClients (trainer_data) {
        var total_programs_per_client;
        var details_arr = [];
        var ctr         = 1;

        for(var key in trainer_data) {
            var data2 = trainer_data[key];
            if(data2.length < 1)
                details_arr.push(<div key={uniqueId()}>No programs have been assigned to clients yet.</div>);

            for(var key2 in data2) {
                var athlete_id   = data2[key2].athlete_id;
                var first_name   = data2[key2].first_name;
                var last_name    = data2[key2].last_name;
                var date_created = data2[key2].date_created;
                var new_date     = new Date(date_created).toLocaleString([], {month: 'short', day:'2-digit'}); //, hour: '2-digit', minute:'2-digit'});
                var full_name          = first_name + " " + last_name;
                var date_last_used     = data2[key2].ath_prog_date_last_used;
                var last_login_date = "Never";

                if(date_last_used != null)
                    last_login_date = new Date(date_last_used).toLocaleString([], {month: 'short', day:'2-digit'}); //, hour: '2-digit', minute:'2-digit'});

                if(first_name != null && last_name != null) {

                    details_arr.push(<div key={uniqueId()} className="trainerDetailsDataRow">
                                        <span className="trainerDetailsLeftCol">
                                            {ctr}. {full_name}
                                            <br/>
                                            <span className="trainerDetailsLeftCol_ProgramCol">
                                                <b>Program:</b> {data2[key2].name}
                                            </span>
                                            <br/>
                                            <b>Created:</b> {new_date}
                                        </span>

                                        <span className="trainerDetailsMiddleCol">
                                            Last login: { last_login_date }

                                        </span>
                                        <span className="trainerDetailsRightCol"
                                              onClick = {this.sendTrainerTextMsg.bind(this, athlete_id, full_name, data2[key2].name, last_login_date)}>
                                            <FontAwesomeIcon icon="sms"
                                                             className="modalAlertIcon"
                                                             style={{color: Colors.default_blue}}/>
                                        </span>
                                        { /*}<div className="trainerDetailsLastUsedRow">

                                        </div>*/ }
                                    </div>)
                    ctr++;
                }
            }

            return details_arr;
        }
    }

    trainerDetails = () => {
            var error = this.state.error;
            var profile_img_src = require("../../images/icons/user_profile/user_profile.png");
            var data  = this.state.trainerDetail;
            var phone = this.state.phone;

            var tmp_phone = phone.toString().length;
            if(tmp_phone < 7) phone = "n/a";

            var total_programs_per_client = <div className="trainerDetailsRow">
                                                    <span className="trainerDetailsLeftColTitle">
                                                        Client
                                                    </span>
                                                    <span className="trainerDetailsMiddleColTitle">

                                                    </span>
                                                    <span className="trainerDetailsRightColTitle">
                                                        Msg Trainer
                                                    </span>
                                                    <div>
                                                        {this.getTrainerClients(data)}
                                                    </div>
                                            </div>
            //<div className="trainerDetailsRow"><br/><br/></div>

            var details =  <span className="rowTrainerDetail">
                                     { /********** PROFILE PHOTO *********/ }
                                     <span className="clientNewProfilePhoto">
                                       <img id="clientDetailProfilePhoto"
                                            src={profile_img_src}
                                            style={{position:"relative", top:"-25px",maxWidth:"250px", maxHeight:"250px"}}
                                        />
                                    </span>
                                    <br/>
                                    <div style={{position:"relative", top:"-25px", fontSize: 26, fontFamily: "UnitedSansRgMd"}}>
                                           { this.props.trainerName }
                                           <br/>
                                           { this.props.trainerCompanyName}
                                           <br/>

                                   </div>
                                       <div>
                                           { /*}<span className="clientDetailProfileLabelText">Member Since: { this.state.date_since } </span> <p/><br/>*/ }
                                           <span className="clientDetailProfileLabelText">Phone: { phone } </span>
                                       </div>
                                        <div>
                                            { /*}<span className="clientDetailProfileLabelText">Member Since: { this.state.date_since } </span> <p/><br/>*/ }
                                            <span className="clientDetailProfileLabelText">Email: { this.props.trainerEmail } </span>
                                        </div>
                                        { /*}<div>
                                            <br/>
                                            <span   style= {{paddingLeft:"10px", paddingRight:"3px",  cursor: "pointer"}}
                                                    href= {'/client/edit/' + trainer_id }
                                                    onClick={this.handleAddMember.bind(this)}>EDIT
                                            </span>
                                            <span> | </span>
                                            <span   style= {{paddingLeft:"3px", cursor: "pointer"}}
                                                    onClick={this.suspendMember.bind(this)}>{suspend_label} MEMBER
                                            </span>
                                        </div>*/ }
                                        <div className="trainerDetailInfoRow">
                                            <span   className = "trainerDetailLinks1"
                                                    onClick={this.editTrainerProfile.bind(this)}>Edit Profile
                                            </span>
                                            <span> | </span>

                                            <span   className = "trainerDetailLinks2"
                                                    onClick={this.deleteMember.bind(this)}
                                                    >Delete Trainer
                                            </span>
                                        <br/>
                                            <span   className = "trainerDetailLinks3"
                                                    onClick={this.sendSignupEmail.bind(this)}>Email: Trainer Signup
                                            </span>
                                            <span> | </span>
                                            <span   className = "trainerDetailLinks4"
                                                    onClick={this.sendResetPasswordEmail.bind(this)}>Email: Reset Trainer Password
                                            </span>
                                            {/*}<span> | </span>
                                            <span   style= {{paddingLeft:"3px"}}
                                                    onClick={this.handleDeleteMember.bind(this, trainer_id, full_name)}>DELETE MEMBER
                                            </span>*/ }
                                        </div>
                                        <br/>
                                        <span style={{paddingTop:0, fontSize: 16, color: "red"}}>{error}</span>
                                        <div>
                                             { total_programs_per_client }
                                        </div>
                                        <br/>
                         </span>

            return details;
    }

    trainerForm = () => {
        var form = <form onSubmit={this.handleSubmit} className="form trainerPersonalForm" >
                        { /********* LOCATION *********/ }
                        <Row className="grid">
                              <Col xs={12} sm={12} md={12}>
                                  <span className="formLabel">
                                      Gym Location
                                  </span>
                              </Col>
                        </Row>

                        <Row className="grid">
                              <Col xs={12} sm={12} md={12}>
                                  <span className="pull-left">
                                      <SortDropdownTrainerLocation  locationLabel   = {this.props.trainerCompanyName}
                                                                    locationResults = {this.locationResults.bind(this)} />
                                  </span>
                              </Col>
                        </Row>
                        { /********* FIRST NAME *********/ }
                        <div className="iconAddExercise25pxVertSpacer"></div>
                        <Row className="grid">
                              <Col xs={12} sm={12} md={12}>
                                  <span className="formLabel">
                                      First Name
                                  </span>
                              </Col>
                        </Row>
                        <Row className="grid">
                              <Col xs={12} sm={12} md={12}>
                                  <span>
                                        <input type        = "text"
                                               placeholder = "First Name"
                                               value       = {this.state.first_name}
                                               onChange    = {this.handleFirstNameChange.bind(this)}
                                               className   = "input-lg tf_addExercise" />

                                  </span>
                              </Col>
                        </Row>
                        { /********* LAST NAME *********/ }
                        <div className="iconAddExercise25pxVertSpacer"></div>
                        <Row className="grid">
                              <Col xs={12} sm={12} md={12}>
                                  <span className="formLabel">
                                      Last Name
                                  </span>
                              </Col>
                        </Row>
                        <Row className="grid">
                              <Col xs={12} sm={12} md={12}>
                                  <span>
                                          <input type="text"
                                                 placeholder = "Last Name"
                                                 value={this.state.last_name}
                                                 onChange  = {this.handleLastNameChange.bind(this)}
                                                 className = "input-lg tf_addExercise" />
                                  </span>
                              </Col>
                        </Row>

                        { /********* EMAIL *********/ }
                        <div className="iconAddExercise25pxVertSpacer"></div>
                        <Row className="grid">
                              <Col xs={12} sm={12} md={12}>
                                  <span className="formLabel">
                                      Email
                                  </span>
                              </Col>
                        </Row>
                        <Row className="grid">
                              <Col xs={12} sm={12} md={12}>
                                  <span>
                                         <input type="text"
                                                placeholder = "Email Address"
                                                value={this.state.email}
                                                onChange  = {this.handleEmailChange.bind(this)}
                                                className = "input-lg tf_addExercise" />

                                  </span>
                              </Col>
                        </Row>

                        { /********* Phone *********/ }
                        <div className="iconAddExercise25pxVertSpacer"></div>
                        <Row className="grid">
                              <Col xs={12} sm={12} md={12}>
                                  <span className="formLabel">
                                      Phone Number
                                  </span>
                              </Col>
                        </Row>
                        <Row className="grid">
                              <Col xs={12} sm={12} md={12}>
                                 { /*} <span>
                                        <input type        = "text"
                                               className   = "input-lg tf_addExercise"
                                               style       = {{float:"left",width:"200px"}}
                                               placeholder = "Phone Number"
                                               value       = {this.state.phone}
                                               onChange    = {this.handlePhoneChange.bind(this)}/>
                                       </span> */ }
                                  <ReactPhoneInput defaultCountry={'us'}
                                                   value       = {this.state.phone}
                                                   onChange={this.handlePhoneChange.bind(this)}/>

                              </Col>
                        </Row>
                </form>

        return form;
    }

    trainerFormFooter = () => {
        var btns = <span>
                        <span onClick = { () => this.cancel()} >
                            <LoaderButton
                              height    = {38}
                              width     = {150}
                              btncolor  = { Colors.cancel_button_bg }
                              type      = "button"
                              text      = "Cancel"
                              className="modalBasicsBtnClose"
                            />
                        </span>
                        <span className="modalBasicsFooterXPosSpacer"/>
                        <span onClick = { () => this.handleSubmit()}>
                            <LoaderButton
                                //disabled={!this.validateForm()}
                                isLoading={this.state.isLoading}
                                height    = {38}
                                width     = {150}
                                btncolor  = { Colors.ok_button_bg }
                                text    = "Submit"
                                type    = "submit"
                                loadingText="Saving …"
                            />
                       </span>
                   </span>

        return btns;
    }

    trainerDetailsFooter = () => {
        var btn = <span onClick = { () => this.cancel()} >
                        <LoaderButton
                          height    = {38}
                          width     = {150}
                          btncolor  = { Colors.cancel_button_bg }
                          type      = "button"
                          text      = "Done"
                          className="modalBasicsBtnClose"
                        />
                  </span>

        return btn;
    }

    locationResults = (id, location_abbrev) => {
        console.log("company id: " + id);
        this.setState({
            trainerCompanyId: id,
            trainerLocationAbbrev: location_abbrev
        }, function(){
            //this.getMemberList();
        })
    }

    render() {
        var notes = this.props.notes;
        var form_height = 300;


        var trainer_details = "";
        var trainer_form    = "";
        var trainer_footer  = "";

        if(this.state.showTrainerForm) {
            form_height    = 490;
            trainer_form   = this.trainerForm();
            trainer_footer = this.trainerFormFooter();
        } else {
            console.log("trainerDetails.......");
            trainer_details = this.trainerDetails();
            trainer_footer  = this.trainerDetailsFooter();
        }

        let closeModalAlert          = () => this.setState({ showModalAlert: false }); //close simple modal window
        let closeModalTrainerTextMsg = (error) => this.setState({ showModalTrainerTextMsg: false, trainerTextPhone: 0, error: error }); //close modal window
        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
                size="xl"
                dialogClassName="modal-90w"
                style={{display:"inline-block", width: "1000px !important"}}
              >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title" className="fontSize26px">
                        <FontAwesomeIcon icon="user-circle"
                                         className="modalBasicsTitleIcon"
                                         style={{ position:"relative", color: Colors.primary_color}}/>
                        <span className="modalBasicsTitle">
                             Trainer Profile
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className="modalBasicsBody" style={{display:"inline-block", width:"100%", height: form_height}}>
                            { /********** TRAINER DETAILS *********/ }
                            { trainer_details }
                            { /********** OR EDIT TRAINER DATA *********/ }
                            { trainer_form }
                    </span>
                </Modal.Body>
                <Modal.Footer>
                    { trainer_footer }
                </Modal.Footer>

                  {this.state.showModalAlert ?
                      <ModalAlert
                          onHide         = {closeModalAlert}
                          alertFunction  = {this.alertFunction}     // custom function to call within modal
                          alertAction    = {this.state.alertAction} // flag used for above function
                          alertObject    = {this.state.alertObject} // vars used for above function
                          showModalAlert = {this.state.showModalAlert}
                          messageTitle   = {this.state.modalAlertTitleText}
                          messageBody    = {this.state.modalAlertBodyText}
                      />
                  : null}
                  {this.state.showModalTrainerTextMsg ?
                      <span className="trainerTextMsgBackground"></span>
                   : null}

                  {this.state.showModalTrainerTextMsg ?
                        <ModalTrainerTextMsg
                            onHide                  = {closeModalTrainerTextMsg}
                            trainerId               = {this.state.trainerId}
                            trainerName             = {this.state.trainerName}
                            trainerPhone            = {this.state.trainerTextPhone}
                            athleteId               = {this.state.athleteId}
                            athleteName             = {this.state.athleteName}
                            athleteLastLogin        = {this.state.athleteLastLogin}
                            programName             = {this.state.programName}
                            showModalTrainerTextMsg = {this.state.showModalTrainerTextMsg}
                        />
                   : null}
              </Modal>

        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalTrainerDetail.js